<template>
  <div class="login" @keyup="clearErrors()">
    <div class="container" style="max-width: 300px;">
      <div class="section">
        <img alt="BrandXads Logo" src="../assets/bxa-logo.png" />
      </div>
      <div class="section">
        <h3 class="is-size-3">Sign In</h3>
        <form @submit.prevent="login">
          <div class="field">
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="form.email"
                    placeholder="Email"
                  />
                </p>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input
                    class="input"
                    type="password"
                    v-model="form.password"
                    placeholder="Password"
                  />
                </p>
              </div>
            </div>
          </div>
          <button type="submit" class="button is-info is-outlined is-fullwidth">
            Login
          </button>
        </form>
        <p style="padding-top: 12px;" class="has-text-danger">
          {{ errorText }}
        </p>
      </div>
      <div class="section">
        <button class="button is-fullwidth is-info" @click="withGoogle">
          Auth via Google
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      errorText: ""
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(() => {
          this.successAction();
        })
        .catch(err => {
          this.errorAction(err);
        });
    },
    withGoogle() {
      // Login in with Google
      var provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("https://www.googleapis.com/auth/contacts.readonly");

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
          this.successAction();
        })
        .catch(err => {
          this.errorAction(err);
        });
    },
    successAction() {
      window.location = "/dashboard";
    },
    errorAction(err) {
      this.errorText = err;
    },
    clearErrors() {
      this.errorText = "";
    }
  }
};
</script>

<style scoped>
body {
  background: #edf2f7;
}
</style>
